<template>
  <div class="pagination-component">
    <div class="pagination">
      <a href="#" v-on:click="returnOnePage()"><i class="fas fa-step-backward"></i></a>
      <a v-for="page in pagesQuantity" v-on:click="goToPage(page)" href="#" :class="(currentlyPage == page)? 'active': ''">{{ page }}</a>
<!--      <a href="#">3</a>-->
<!--      <a href="#">4</a>-->
<!--      <a href="#">5</a>-->
<!--      <a href="#">6</a>-->
      <a href="#" v-on:click="goOnePage()"><i class="fas fa-step-forward"></i></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationButtons",
  props:[
    'pagesQuantity',
    'currentlyPage'
  ],
  data(){
    return{
      modal: false
    }
  },
  methods:{
    returnOnePage(){
      if (this.currentlyPage > 1){
        this.$emit("update:returnCurrentlyPage", this.currentlyPage-1);
      }
    },
    goOnePage(){
      if (this.currentlyPage < this.pagesQuantity){
        this.$emit("update:returnCurrentlyPage", this.currentlyPage+1);
      }
    },
    goToPage(page){
      this.$emit("update:returnCurrentlyPage", page);
    }
  },
}
</script>

<style scoped>

.pagination-component{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.pagination {
  display: inline-block;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color .3s;
  font-size: 24px;
}

.pagination a.active {
  background-color: #0077BD;
  color: white;
  border-radius: 5px;
}


</style>
